import React from 'react';

import Sad from './ressources/images/face-sad.png';
import Neutral from './ressources/images/face-neutral.png';
import Happy from './ressources/images/face-happy.png';

export default class Amount extends React.Component {
    render() {
        return(
            <div className="hi-side-box">
                <span className="hi-side-subtitle">Soma</span>
                <div className="hi-rating-input">
                    <span className="hi-detractor-label small">Detratores</span>
                    <img className="hi-img-face" src={Sad} title="sad" alt="sad" />
                    <input
                        type="number"
                        value={this.props.detractor}
                        disabled />
                </div>
                <div className="hi-rating-input">
                    <span className="hi-neutral-label small">Neutros</span>
                    <img className="hi-img-face" src={Neutral} title="neutral" alt="neutral" />
                    <input
                        type="number"
                        value={this.props.neutral}
                        disabled />
                </div>
                <div className="hi-rating-input">
                    <span className="hi-promoter-label small">Promotores</span>
                    <img className="hi-img-face" src={Happy} title="happy" alt="happy" />
                    <input
                        type="number"
                        value={this.props.promoter}
                        disabled />
                </div>
            </div>
        );
    }
}